
import React from 'react';
import { Button } from "@/components/ui/button";
import { Check, Key, XCircle } from 'lucide-react';
import { usePassword } from '@/contexts';

interface PasswordStatusCardProps {
  onReset: () => void;
  onClear: () => void;
}

const PasswordStatusCard = ({ onReset, onClear }: PasswordStatusCardProps) => {
  const { hasPassword } = usePassword();
  
  return (
    <div className="space-y-6">
      <div className="text-center">
        <div className="flex justify-center">
          <div className="bg-green-100 dark:bg-green-900/20 p-4 rounded-full">
            <Check className="h-10 w-10 text-green-600 dark:text-green-500" />
          </div>
        </div>
        <h3 className="mt-4 text-xl font-semibold">Password Protection Active</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Your application is protected with a password
        </p>
      </div>
      
      <div className="space-y-3">
        <Button 
          onClick={onReset}
          variant="outline" 
          className="w-full border-dashed"
        >
          <Key className="mr-2 h-4 w-4" />
          Reset Password
        </Button>
        
        <Button 
          onClick={onClear}
          variant="destructive" 
          className="w-full"
        >
          <XCircle className="mr-2 h-4 w-4" />
          Remove Password Protection
        </Button>
      </div>
    </div>
  );
};

export default PasswordStatusCard;
